#!/usr/bin/env node
require("ts-node").register()
import "./cli"
